import { RefObject, useEffect } from 'react';

export function useClickOutside(ref: RefObject<HTMLDivElement>, activate: boolean, handler: () => void) {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (ref.current && event.target instanceof HTMLElement && !ref.current.contains(event.target)) {
                handler();
            }
        }

        if (activate) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [ref, activate, handler]);
}
